import {
  CHANGE_SIDEBAR_VISIBILITY,
  CHANGE_MOBILE_SIDEBAR_VISIBILITY,
  COLLAPSE_SIDEBAR,
  EXPAND_SIDEBAR,
} from '../actions/sidebarActions';

const initialState = {
  show: false,
  collapse: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case COLLAPSE_SIDEBAR:
      return { ...state, collapse: true };
    case EXPAND_SIDEBAR:
      return { ...state, collapse: false };
    case CHANGE_SIDEBAR_VISIBILITY:
      return { ...state, collapse: !state.collapse };
    case CHANGE_MOBILE_SIDEBAR_VISIBILITY:
      return { ...state, show: !state.show };
    default:
      return state;
  }
}
